<div class="row justify-content-center login">
  <div
    class="col-12"
    *ngIf="!register"
    class="content-login">
    <h2>Iniciar sesión</h2>
    <form [formGroup]="loginForm">
      <div *ngIf="firstStep">
        <small>Para comenzar ingresá tu email</small>

        <mat-form-field class="full-width user">
          <mat-label>Email</mat-label>
          <input
            matInput
            formControlName="email"
            type="email"
            name="email"
            autocomplete="email"
            (keyup.enter)="captchaRef.execute()" />
          <mat-error *ngIf="userIngresado.errors?.required">Campo requerido</mat-error>
          <mat-error *ngIf="userIngresado.errors?.minlength">Minimo 8 caracteres</mat-error>
          <mat-error *ngIf="userIngresado.errors?.noUser"
            >El email ingresado es incorrecto o no existe</mat-error
          >
        </mat-form-field>
        <re-captcha
          #captchaRef="reCaptcha"
          (resolved)="comprobarMail($event)"
          [siteKey]="recaptchaGoogle"
          size="invisible">
        </re-captcha>
        <button
          type="button"
          class="continue"
          mat-raised-button
          color="primary"
          [disabled]="userIngresado.invalid"
          (click)="captchaRef.execute()">
          Continuar
        </button>
        <button
          type="button"
          mat-stroked-button
          color="primary"
          (click)="goToRegister()">
          Crear cuenta
        </button>
        <p class="link_video">
          <mat-icon>smart_display</mat-icon
          ><a
            href="https://www.youtube.com/watch?v=Fy37FKC_kS8"
            target="_blank"
            >Ver video instructivo de ingreso a la página</a
          >
        </p>
        <hr />
        <small style="color: #333; line-height: 1.3">
          Si tenés problemas para iniciar sesión escribinos a
          <a href="mailto:feedback_nuevapagina@compragamer.net"
            >feedback_nuevapagina&#64;compragamer.net</a
          >
        </small>
      </div>
      <div *ngIf="secondStep">
        <small>Ahora ingresá la contraseña</small>
        <mat-chip-listbox aria-label="Fish selection">
          <mat-chip-option
            color="primary"
            (removed)="remove()"
            >{{ userIngresado.value }} <mat-icon matChipRemove>cancel</mat-icon></mat-chip-option
          >
        </mat-chip-listbox>

        <re-captcha
          #captchaRef3="reCaptcha"
          (resolved)="sendPassword($event)"
          [siteKey]="recaptchaGoogle"
          size="invisible">
        </re-captcha>
        <mat-form-field class="full-width pass">
          <mat-label>Contraseña</mat-label>
          <input
            matInput
            formControlName="contrasenia"
            [type]="hide2 ? 'password' : 'text'" />
          <button
            mat-icon-button
            matSuffix
            class="boton_hide"
            type="button"
            (click)="hide2 = !hide2"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide2">
            <mat-icon>{{ hide2 ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="password.errors?.required && password.touched"
            >Campo requerido</mat-error
          >
          <mat-error *ngIf="password.errors?.noPass"
            >La contraseña ingresada es incorrecta</mat-error
          >
        </mat-form-field>
        <small class="aviso">{{ disclaimer }}</small>
        <button
          class="continue"
          [disabled]="password.invalid"
          mat-raised-button
          color="primary"
          (click)="loginUser()">
          Ingresar
        </button>
        <button
          mat-stroked-button
          color="primary"
          (click)="captchaRef3.execute()">
          Obtener mi clave
        </button>
      </div>
      <div *ngIf="thirdStep">
        <small>Realizá el cambio de contraseña</small>
        <mat-chip-listbox aria-label="Fish selection">
          <mat-chip-option
            color="primary"
            (removed)="remove()"
            >{{ userIngresado.value }} <mat-icon matChipRemove>cancel</mat-icon></mat-chip-option
          >
        </mat-chip-listbox>
        <form
          [formGroup]="changePassword"
          *ngIf="!message">
          <mat-form-field class="full-width firstInput">
            <mat-label>Código enviado</mat-label>
            <input
              matInput
              formControlName="codigo"
              type="text" />

            <mat-error *ngIf="changePassword.controls['codigo'].errors?.required"
              >Campo requerido</mat-error
            >
            <mat-error *ngIf="changePassword.controls['codigo'].errors?.cod_error"
              >Código inválido. Chequear que no contenga espacios y estén todos los
              caracteres</mat-error
            >
          </mat-form-field>
          <mat-form-field class="full-width secondInput">
            <mat-label>Nueva contraseña</mat-label>
            <input
              matInput
              formControlName="password"
              [type]="hide ? 'password' : 'text'" />
            <button
              mat-icon-button
              matSuffix
              class="boton_hide"
              (click)="hide = !hide"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide"
              type="button">
              <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="changePassword.controls['password'].errors?.required"
              >Campo requerido</mat-error
            >
            <mat-error *ngIf="changePassword.controls['password'].errors?.pattern"
              >La contraseña debe tener minimo 8 caracteres, una mayúscula y un número</mat-error
            >
          </mat-form-field>
          <mat-form-field class="full-width secondInput">
            <mat-label>Repeti la nueva contraseña</mat-label>
            <input
              matInput
              formControlName="passwordRep"
              [type]="hide1 ? 'password' : 'text'" />
            <button
              mat-icon-button
              matSuffix
              class="boton_hide"
              (click)="hide1 = !hide1"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide1"
              type="button">
              <mat-icon>{{ hide1 ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="changePassword.controls['passwordRep'].errors?.required"
              >Campo requerido</mat-error
            >
            <mat-error *ngIf="changePassword.controls['passwordRep'].errors?.pattern"
              >La contraseña debe tener minimo 8 caracteres, una mayúscula y un número</mat-error
            >
            <mat-error *ngIf="changePassword.controls['passwordRep'].hasError('NoPassswordMatch')"
              >Las contraseñas no coinciden</mat-error
            >
          </mat-form-field>
        </form>
        <p
          *ngIf="message"
          style="margin-top: 1em">
          {{ message }}
        </p>
        <re-captcha
          #captchaRef2="reCaptcha"
          (resolved)="sendPassword($event)"
          [siteKey]="recaptchaGoogle"
          size="invisible">
        </re-captcha>
        <re-captcha
          #captchaRef4="reCaptcha"
          (resolved)="loginUserReset($event)"
          [siteKey]="recaptchaGoogle"
          size="invisible">
        </re-captcha>
        <button
          class="continue"
          mat-raised-button
          color="primary"
          [disabled]="changePassword.invalid"
          (click)="captchaRef4.execute()">
          Cambiar contraseña
        </button>
        <button
          mat-stroked-button
          color="primary"
          (click)="captchaRef5.execute()"
          *ngIf="!message">
          Enviar nuevamente el código
        </button>
        <re-captcha
          #captchaRef5="reCaptcha"
          (resolved)="sendPassword($event)"
          [siteKey]="recaptchaGoogle"
          size="invisible">
        </re-captcha>
        <small
          class="problemas-sesion"
          (click)="goToLoginFromRec()"
          *ngIf="!message"
          >Ingresar con mi antigua contraseña</small
        >
        <button
          mat-stroked-button
          color="primary"
          (click)="captchaRef2.execute()"
          *ngIf="message">
          Obtener mi clave
        </button>
      </div>
    </form>
  </div>
</div>
<div *ngIf="register">
  <cgw-register (returnLogin)="returnLogin($event)"></cgw-register>
</div>
